const buildElementSelector = (element) => {
    let selector = element.tagName.toLowerCase();
    if (element.id) {
        selector += `#${CSS.escape(element.id)}`;
    }
    element.classList.forEach((className) => {
        selector += `.${CSS.escape(className)}`;
    });
    return selector;
};
export const getElementPath = (element) => {
    const segments = [];
    let current = element;
    while (current && current !== document.body && current !== document.documentElement) {
        segments.unshift(buildElementSelector(current));
        current = current.parentElement;
    }
    return segments.join(' > ');
};
